/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AppHeaderQueryVariables = {||};
export type AppHeaderQueryResponse = {|
  +appInfo: {|
    +tag: string
  |}
|};
export type AppHeaderQuery = {|
  variables: AppHeaderQueryVariables,
  response: AppHeaderQueryResponse,
|};
*/


/*
query AppHeaderQuery {
  appInfo {
    tag
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AppInfo",
    "kind": "LinkedField",
    "name": "appInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppHeaderQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AppHeaderQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a3041bd9a1b9e2edbd55618c06f0252b",
    "id": null,
    "metadata": {},
    "name": "AppHeaderQuery",
    "operationKind": "query",
    "text": "query AppHeaderQuery {\n  appInfo {\n    tag\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '05224f2c6625d2877168f451fc6487c7';

module.exports = node;
